import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import i18n from './ChargingPointsChart-i18n';
import { Grid, GridItem, Spacer } from '../../../helpers';
import { H2, H3 } from '../../../primitives';
import styled from '@emotion/styled';
import { rem } from 'polished';

const StyledTitle = styled(H2)`
  text-align: center;
`;
const StyledSubtitle = styled(H3)`
  text-align: center;
  font-weight: 400;
`;

const StyledChartContainer = styled.div`
  padding-left: ${rem(50)};
`;

const ChargingPointChart = ({ locale, data }: ChargingPointChartProps) => {
  return (
    <div>
      <Grid columns={12}>
        <GridItem
          size={{ zero: 12, medium: 10, large: 8 }}
          push={{ zero: 0, medium: 1, large: 2 }}
        >
          <StyledTitle>{i18n.title[locale]}</StyledTitle>
          <StyledSubtitle>{i18n.subtitle[locale]}</StyledSubtitle>
        </GridItem>
      </Grid>
      <Spacer space="beta" />
      <StyledChartContainer>
        <ResponsiveContainer aspect={16 / 9}>
          <LineChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" angle={-45} textAnchor="end" height={60} />
            <YAxis
              yAxisId="left"
              orientation="left"
              tickFormatter={(value) => value.toLocaleString()}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tickFormatter={(value) => value.toLocaleString()}
              hide
            />
            <Tooltip formatter={(value) => value.toLocaleString()} />
            <Legend
              layout="vertical"
              align="center"
              verticalAlign="middle"
              wrapperStyle={{
                fontWeight: 400,
                lineHeight: 1.5,
                transform: 'rotate(-90deg)',
                position: 'absolute',
                left: -90,
              }}
              iconType="plainline"
              iconSize={0}
            />
            <Line
              yAxisId="left"
              type="linear"
              dataKey="chargingPoints"
              stroke="#4A90E2"
              name={i18n.chargingPoints[locale]}
              activeDot={{ r: 6 }}
            />
            <Line
              yAxisId="left"
              type="linear"
              dataKey="locations"
              stroke="#7ED321"
              name={i18n.locations[locale]}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledChartContainer>
    </div>
  );
};

export type ChargingPointChartProps = {
  locale: string;
  data: {
    date: string;
    chargingPoints: number;
    locations: number;
  }[];
};

export default ChargingPointChart;
